
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"50.944","height":"50.944","viewBox":"0 0 50.944 50.944"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{attrs:{"id":"backDrop","d":"M40.331 51.044H10.613A10.51 10.51 0 010 40.431V10.713A10.51 10.51 0 0110.613.1h29.718a10.51 10.51 0 0110.613 10.613v29.718a10.785 10.785 0 01-10.613 10.613z","transform":"translate(0 -.1)","fill":"#292e35"}}),_c('g',{attrs:{"transform":"translate(8.278 8.278)"}},[_c('circle',{attrs:{"cx":"17.194","cy":"17.194","opacity":".2","fill":"#18db38","r":"17.194"}}),_c('circle',{attrs:{"cx":"13.373","cy":"13.373","transform":"translate(3.821 3.821)","fill":"#18db38","r":"13.373"}}),_c('path',{staticClass:"d",attrs:{"d":"M16.132 21.651a1.291 1.291 0 01-1.7 0l-2.97-2.971a1.291 1.291 0 010-1.7 1.291 1.291 0 011.7 0l2.972 2.972a1.284 1.284 0 01-.002 1.699z"}}),_c('path',{staticClass:"d",attrs:{"d":"M14.858 21.652a1.291 1.291 0 010-1.7l7.217-7.217a1.291 1.291 0 011.7 0 1.291 1.291 0 010 1.7l-7.217 7.217a1.291 1.291 0 01-1.7 0z"}})])])
          )
        }
      }
    